import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StoreProvider } from "./contexts/StoreContext";
import { ExchangeRateProvider } from "./contexts/ExchangeRateContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./components/Navigation";
import Dashboard from "./components/Dashboard";
import Stores from "./components/Stores";
import Sales from "./components/Sales";
import Expenses from "./components/Expenses";
import Inventory from "./components/Inventory";
import Reports from "./components/Reports";
import AccountsPayable from "./components/AccountsPayable";
import ExchangeRate from "./components/ExchangeRate";
import UserManagement from "./components/UserManagement";
import BreakEvenAnalysis from "./components/BreakEvenAnalysis";
import InitialInventoryValues from "./components/InitialInventoryValues";
import CashControl from "./components/CashControl";
import TelegramSetup from "./components/TelegramSetup";
import Payroll from "./components/Payroll";
import TestTabs from "./components/TestTabs";
import Cashea from "./components/Cashea";
import BankReconciliation from "./components/BankReconciliation";
import ManualReconciliation from "./components/ManualReconciliation";
import WelcomeModal from "./components/WelcomeModal";
import { TenantProvider } from "./contexts/TenantContext";
import KontrolAdmin from "./components/KontrolAdmin";
import BankSettings from "./components/BankSettings";
import MonthlyReportPDF from "./components/MonthlyReportPDF";
import DailyExpenseReport from "./components/DailyExpenseReport";
import AttendanceControl from "./components/AttendanceControl";
import PaymentApproval from "./components/PaymentApproval";
import PaymentPlanning from "./components/PaymentPlanning";
import BankTransfers from "./components/BankTransfers";
import BankAvailability from "./components/BankAvailability";
import POSComparison from "./components/POSComparison";
import CashInTransit from "./components/CashInTransit";
import AccountsReceivable from "./components/AccountsReceivable";

function App() {
  // Detectar token de Kontrol en URL y hacer auto-login
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const kt = params.get('kt');
    const tenant = params.get('tenant');
    if (kt && tenant) {
      localStorage.setItem('farmavida_token', kt);
      localStorage.setItem('tenant_id', tenant);
      // Limpiar URL y recargar para que AuthContext tome el token
      window.history.replaceState({}, '', '/');
      window.location.reload();
    }
  }, []);

  return (
    <div className="App min-h-screen bg-gray-50">
      <AuthProvider>
        <ProtectedRoute>
          <ExchangeRateProvider>
            <StoreProvider>
              <BrowserRouter><TenantProvider>
                <Navigation />
                <WelcomeModal />
                <main className="container mx-auto px-4 py-8">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/stores" element={<Stores />} />
                    <Route path="/sales" element={<Sales />} />
                    <Route path="/expenses" element={<Expenses />} />
                    <Route path="/inventory" element={<Inventory />} />
                    <Route path="/initial-inventory" element={<InitialInventoryValues />} />
                    <Route path="/cash-control" element={<CashControl />} />
                    <Route path="/cashea" element={<Cashea />} />
                    <Route path="/bank-reconciliation" element={<BankReconciliation />} />
                    <Route path="/conciliacion-manual" element={<ManualReconciliation />} />
                    <Route path="/kontrol-admin" element={<KontrolAdmin />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/accounts-payable" element={<AccountsPayable />} />
                    <Route path="/payment-approval" element={<PaymentApproval />} />
                    <Route path="/payment-plans" element={<PaymentPlanning />} />
                    <Route path="/traspasos" element={<BankTransfers />} />
                    <Route path="/bank-availability" element={<BankAvailability />} />
                    <Route path="/pos-comparison" element={<POSComparison />} />
                    <Route path="/dinero-en-transito" element={<CashInTransit />} />
                    <Route path="/cuentas-por-cobrar" element={<AccountsReceivable />} />
                    <Route path="/exchange-rate" element={<ExchangeRate />} />
                    <Route path="/break-even" element={<BreakEvenAnalysis />} />
                    <Route path="/users" element={<UserManagement />} />
                    <Route path="/whatsapp-setup" element={<TelegramSetup />} />
                    <Route path="/payroll" element={<Payroll />} />
                    <Route path="/bank-settings" element={<BankSettings />} />
                    <Route path="/monthly-report" element={<MonthlyReportPDF />} />
                    <Route path="/daily-report" element={<DailyExpenseReport />} />
                    <Route path="/test-tabs" element={<TestTabs />} />
                    <Route path="/attendance" element={<AttendanceControl />} />
                  </Routes>
                </main>
              </TenantProvider></BrowserRouter>
            </StoreProvider>
          </ExchangeRateProvider>
        </ProtectedRoute>
      </AuthProvider>
    </div>
  );
}

export default App;